import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const Overlay = styled.div`
  /* Layout Properties */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: fixed;
  align-content: center;
  justify-content: center;
  z-index: 10;
  /* UI Properties */
  background: #0000003d 0 0 no-repeat padding-box;
  opacity: 1;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
`;
Overlay.displayName = 'Overlay';
interface IContainerProps {
  actualPage?: string;
}
export const Container = styled.div<IContainerProps>`
  /* Layout Properties */

  width: 1229px;
  height: 750px;
  align-self: center;
  justify-self: center;
  /* UI Properties */
  background: #ffffff 0 0 no-repeat padding-box;
  box-shadow: 0 9px 26px #0000003d;
  border-radius: 8px;
  opacity: 1;
  display: grid;
  grid-template-columns: 284px 873px;
  grid-column-gap: 24px;
  padding: 20px 24px;
  animation-duration: 0.2s;
  animation-timing-function: ease;
  animation-delay: 0s;
  animation-iteration-count: 1;
  animation-direction: normal;
  animation-fill-mode: forwards;
  animation-play-state: running;
  animation-name: scaleup;
  animation-duration: 0.3s;
  transform: scale3d(0, 0, 0);
  opacity: 0;

  @keyframes scaleup {
    to {
      transform: scale3d(1, 1, 1);
      opacity: 1;
    }
  }
`;
Container.displayName = 'Container';
export const Header = styled.div`
  text-align: left;
  font-size: 18px;
  font-weight: 600;
  color: #1b203a;
  margin-bottom: 16px;
`;
Header.displayName = 'Header';
export const CloseButton = styled.button`
  /* Layout Properties */
  width: 12px;
  height: 12px;
  align-self: end;
  border: none;
  margin: 0 0 26px 0;
  /* UI Properties */
  color: #333333;
  background-color: transparent;
  :hover {
    color: #859be3;
  }
`;

export const HeaderBar = styled.div`
  /* Layout Properties */
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  & ${Header} {
    margin: 0;
  }
  &.left {
    height: 50px;
    flex-shrink: 0;
  }
`;

export const Left = styled.div`
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e9edf1;
  height: 100%;
  overflow: hidden;
  row-gap: 18px;
`;
Left.displayName = 'Left';

const HEADING_HEIGHT = 174.28;
const CONTROLS_HEIGHT = 42;
export const Right = styled.div`
  display: grid;
  grid-template-rows: ${HEADING_HEIGHT}px auto ${CONTROLS_HEIGHT}px;
  grid-auto-columns: 100%;
  row-gap: 24px;
  overflow: hidden;
`;
Right.displayName = 'Right';
export const SearchImg = styled.img`
  position: absolute;
  left: 12px;
  z-index: 2;
`;

export const Search = styled.input`
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.161);
  border: none;
  border-radius: 8px;
  font-size: 14px;
  color: #787878;
  height: 36px;
  display: flex;
  align-items: center;
  flex: 1;
  padding-left: 31px;
  padding-right: 8px;
  -webkit-appearance: none;

  ::placeholder {
    color: #787878;
  }
`;
export const SearchContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
  margin-bottom: 24px;
`;
export const FillHeight = styled.div`
  display: flex;
  height: 100%;
`;
export const DivHeadersList = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 24px;
  height: 100%;
  overflow-y: auto;
`;

interface ISelected {
  isSelected?: boolean;
}
export const HeaderContainer = styled.div<ISelected>`
  padding: 12px 9px 6px 12px;
  margin-bottom: 10px;
  border-radius: 8px;
  background: ${({ isSelected }) => (isSelected ? '#f5f7fb' : 'transparent')};
`;
export const DivList = styled.div`
  display: flex;
  margin-top: 12px;
  margin-left: 12px;
  flex-direction: column;
`;
export const OptionText = styled.text<ISelected>`
  margin-bottom: 12px;
  cursor: pointer;
  font-style: normal;
  font-weight: ${({ isSelected }) => (isSelected ? '500' : '400')};
  font-size: 12px;
  line-height: 22px;
  color: ${({ isSelected }) => (isSelected ? '#1b203a' : '#474d66')};
`;
export const HeaderText = styled.text`
  font-weight: 500;
  font-size: 14px;

  cursor: pointer;
  color: #1b203a;
`;
export const FormContainer = styled.form`
  /* Layout Properties */
  width: 100%;
  height: 320px;
  display: flex;
  flex-direction: column;
  padding-left: 32px;
  padding-right: 32px;
  overflow: auto;
  justify-content: start;
  align-items: start;
`;
export const Buttons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  column-gap: 8px;
`;
const ButtonWithTransition = styled.button`
  justify-content: center;
  align-items: center;
  background-color: transparent;
  display: flex;
  border: none;
  padding: 10px 16px;
  font-size: 14px;
  font-weight: 500;
  border-radius: 8px;

  && {
    transition-timing-function: var(--transition-fn);
    transition-duration: 0.2s;
    transition-property: background-color;
  }
`;
export const BlueButton = styled(ButtonWithTransition)`
  color: #1371fe;

  :hover {
    background-color: #f6f8ff;
  }
`;
BlueButton.displayName = 'BlueButton';
export const WhiteButton = styled(ButtonWithTransition)`
  color: #474d66;
  :hover {
    background-color: #f6f8ff;
  }
`;
WhiteButton.displayName = 'WhiteButton';
export const IconChevRightAwesome = styled(FontAwesomeIcon)`
  width: 9px;
  height: 16px;
  margin-left: 8px;
`;
export const IconChevLeftAwesome = styled(FontAwesomeIcon)`
  width: 9px;
  height: 16px;
  margin-right: 8px;
`;

export const HeadingTop = styled.div`
  border-bottom: 2px solid #f6f8ff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-bottom: 24px;
`;

export const AddMoreList = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  column-gap: 69px;
`;

export const SingleInputs = styled.div`
  overflow-y: auto;

  &[data-fieldtype='custom-type-description'] > * {
    height: 60px;
  }
  &[data-fieldtype='Assign Tags'] > * {
    height: 50px;
  }
  & > * {
    height: 44px;
  }
  /* Defaults.  */
  & > .group_warning {
    height: min-content;
  }
  & > .loadmore_wrap {
    height: unset;
  }
  & > *:not(:last-child) {
    margin-bottom: 16px;
  }
`;
SingleInputs.displayName = 'SingleInputs';
